import axios from "axios"
import { useEffect, useState } from "react"
import { getMe } from "services/users/calls"

export const useUser = reRender => {
  const [payload, setPayload] = useState()
  const [error, setError] = useState()

  useEffect(() => {
    const source = axios.CancelToken.source()
    let isMounted = true
    const fetchUser = async () => {
      if (localStorage.getItem("token")) {
        try {
          const {
            payload: { user },
          } = await getMe()
          if (isMounted) {
            setPayload(user)
          }
        } catch (err) {
          if (isMounted) {
            setError(err)
          }
        } finally {
          isMounted
        }
      }
    }
    fetchUser()
    const cleanUp = () => {
      isMounted = false
      source.cancel()
    }
    return cleanUp
  }, [reRender])
  return {
    payload,
  }
}
